import type { ObjectId } from '@freightview/object-id'

import {
  vArray,
  vBoolean,
  vObject,
  vOpt,
  type vOutput,
  vPicklist,
  vString,
  vStringToNumber,
} from '../validation/index.ts'

export const notificationTypes = [
  'missed-pickup',
  'booking-error',
  'rejection',
  'vendor-created',
  'vendor-booked',
  'tracking-change',
  'export',
  'document-batch',
  'doc-center:invalid-email',
  'doc-center:email-finished',
  'load-upload:completed',
  'route-guide:exhausted',
] as const

export type NotificationType = (typeof notificationTypes)[number]

export type Notification = {
  _id: ObjectId
  created: Date
  notificationType: NotificationType
  userId?: ObjectId
  accountId: ObjectId
  title?: string
  text: string
  link?: string
  loadId?: ObjectId
  archivedDate?: Date
  readDate?: Date
  pinned?: boolean
}

export type UserNotification = Omit<Notification, 'accountId'> & {
  continuationToken?: string
}

export const notificationFilterSchema = vObject({
  types: vOpt(vArray(vPicklist(notificationTypes))),
  pinned: vOpt(vBoolean()),
  onlyUnread: vOpt(vBoolean()),
  includeArchived: vOpt(vBoolean()),
  continuationToken: vOpt(vString()),
  limit: vOpt(vStringToNumber()),
})
export type NotificationFilter = vOutput<typeof notificationFilterSchema>

export const updateNotificationStatusSchema = vObject({
  pinned: vOpt(vBoolean()),
  read: vOpt(vBoolean()),
})
export type UpdateNotificationStatus = vOutput<
  typeof updateNotificationStatusSchema
>

export const updateMutedNotificationTypesSchema = vObject({
  types: vArray(vPicklist(notificationTypes)),
  muted: vBoolean(),
})
export type UpdateMutedNotificationTypes = vOutput<
  typeof updateMutedNotificationTypesSchema
>

export interface UserNotificationSettings {
  mutedNotificationTypes?: NotificationType[]
}

export interface UnreadCounts {
  unreadCount: number
}
